import {APIService} from '@/services/api.service';
import {CandidatePoiItem} from '@mobi-components/global-solution';
import {SolutionResponse} from '../solution/solution-support.types';
import {IDomainCategoryDescription} from '../state/global.types';
import {AmexProblem} from './build-problem';

export interface SolutionWithProblem {
  auto_saved: boolean;
  problem: AmexProblem;
  solution_response: SolutionResponse;
  selected_filters: IDomainCategoryDescription[];
  trip_id: string;
  trip_name: string;
  trip_start_time: number;
  trip_end_time: number;
  trip_contexts: CandidatePoiItem[];
}

export async function restoreSolutionsBySessionId(sessionId = '', userId = ''): Promise<SolutionWithProblem[]> {
  try {
    const {sessions} = await APIService.get<{sessions: SolutionWithProblem[]}>(`session-details`, {
      params: {
        trip_id: sessionId,
        user_id: userId,
      },
    });
    return sessions || [];
  } catch {
    return [];
  }
}

export async function restoreSolutionsByUserId(
  userId = '',
  onlyUserSavedTrips = false,
): Promise<SolutionWithProblem[]> {
  try {
    const {sessions} = await APIService.get<{sessions: SolutionWithProblem[]}>(`session`, {
      params: {
        user_id: userId,
        include_auto_saved: !onlyUserSavedTrips,
        include_user_saved: onlyUserSavedTrips,
      },
    });
    return sessions || [];
  } catch {
    return [];
  }
}
